import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VisaoAto } from 'src/app/shared/model/visao-ato.model';

@Component({
    selector: 'app-imprimir-ato',
    templateUrl: './imprimir-ato.component.html',
    styleUrls: ['./imprimir-ato.component.css']
})
export class ImprimirAtoComponent implements OnInit, AfterContentChecked {
    visaoAto: VisaoAto | null;
    imprimirAto = true;
    
    constructor(
        private readonly route: ActivatedRoute,
    ) {}

    ngAfterContentChecked(): void {
        const areaImprimivel = document.querySelector(".conteudo-ato");        
        if (areaImprimivel && this.imprimirAto && this.visaoAto) {
            this.imprimirAto = false;
            setTimeout(() => {
                this.gerarPDF();
            });
        }
    }

    ngOnInit(): void {
        this.route.params.subscribe(() => {
            this.visaoAto = null;
            this.imprimirAto = true;
            this.removerEstiloPadraoDaImpressao();
        });
    }

    obterVisaoAto(visaoAto: VisaoAto) {
        this.visaoAto = visaoAto;       
    }

    removerEstiloPadraoDaImpressao() {
        // Remove o estilo padrão do projeto pois altera a impressão
        const stylesheets = document.querySelectorAll('link[rel="stylesheet"]');
        stylesheets.forEach(sheet => {
            const link = sheet as HTMLLinkElement;
            if (link.href.includes('styles.css')) {
                link.media = 'screen';
            }
        });
    }

    ehVisaoRelacional() {
        if (this.visaoAto) {
            return this.visaoAto.visao.toLowerCase().startsWith('relacional');
        }
        return false;
    }

    gerarPDF() {
        document.title = document.title.replaceAll('/', '-');
        window.focus();
        window.print();
    }

}
